import { rootApi } from "../../api/rootApi";

export const zonePincodeMapApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchZonePincodeApi: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/zonesPincodeMap/fetchZonePincodeMapping`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),

    bulkUploadZonePincodeMap: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/zonesPincodeMap/bulk-csv`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
})
});

export const {
    useFetchZonePincodeApiMutation,
    useBulkUploadZonePincodeMapMutation
} = zonePincodeMapApi;